import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
  FieldArray,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
} from 'reactstrap';
import TextBox from '../../../../shared/components/form/TextBox';
import renderToggleButtonField from '../../../../shared/components/form/ToggleButton';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';
import StudentsScoresTable from './StudentsScoresTable';
import {
  dateFormat,
} from '../../../../helpers/dateFormat';

class SurveyForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleChangeText: PropTypes.func.isRequired,
    handleChangeChecked: PropTypes.func.isRequired,
    handleSort: PropTypes.func.isRequired,
    handleFilterChangeText: PropTypes.func.isRequired,

    showSpinner: PropTypes.func.isRequired,

    submitting: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    encuestaMateriaAlumnos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    spreadsheetId: PropTypes.string.isRequired,
    sheetName: PropTypes.string.isRequired,
    emailColumn: PropTypes.string.isRequired,
    activa: PropTypes.string.isRequired,

    filterValue: PropTypes.string,
    sortColumn: PropTypes.string.isRequired,
    sortType: PropTypes.string.isRequired,
  }

  static defaultProps = {
    submitting: false,
    filterValue: '',
  }

  constructor(props) {
    super(props);
    this.state = {};
    this.checkBoxLabelStyle = {
      marginTop: '0px',
      display: 'flex',
      justifyContent: 'center',
    };
  }

  format = (date = '') => {
    if (date) {
      return dateFormat(date.split('T')[0]);
    }

    return '';
  };

  render() {
    const {
      loading,
      showSpinner,
    } = this.props;

    if (loading) {
      return showSpinner();
    }

    const {
      handleSubmit,
      handleChangeText,
      handleChangeChecked,
      handleSort,
      handleFilterChangeText,
      submitting,
      onBack,
      encuestaMateriaAlumnos,
      filterValue,
      sortColumn,
      sortType,
      spreadsheetId,
      sheetName,
      emailColumn,
      activa,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title" style={{ marginTop: '10px' }}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            <Form inline className="form" onSubmit={handleSubmit}>
              <Col md={12} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos de la encuesta</h5>
                </div>
              </Col>
              <Col md={6} sm={12} lx={4}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Spreadsheet Id</span>
                  <div className="form__form-group-field">
                    <Field
                      name="spreadsheetId"
                      component={TextBox}
                      placeholder="Spreadsheet Id"
                      autoComplete="false"
                      multiple
                      type="text"
                      maxLength="256"
                      disabled={false}
                      defaultValue={spreadsheetId}
                      onBlur={({ target }) => handleChangeText({ target })}
                    />
                  </div>
                </div>
              </Col>
              <Col md={6} sm={12} lx={4}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Nombre de hoja</span>
                  <div className="form__form-group-field">
                    <Field
                      name="sheetName"
                      component={TextBox}
                      placeholder="Nombre de hoja"
                      autoComplete="false"
                      type="text"
                      defaultValue={sheetName}
                      onBlur={({ target }) => handleChangeText({ target })}
                      disabled={false}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={4} sm={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Columna Email</span>
                  <div className="form__form-group-field">
                    <Field
                      name="emailColumn"
                      component={TextBox}
                      placeholder="Columna Email"
                      autoComplete="false"
                      type="text"
                      disabled={false}
                      defaultValue={emailColumn}
                      onBlur={({ target }) => handleChangeText({ target })}
                    />
                  </div>
                </div>
              </Col>
              <Col md={1}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Activa</span>
                  <div className="form__form-group-field" style={{ width: 'auto', margin: '0 0 0 10px' }}>
                    <Field
                      labelStyle={this.checkBoxLabelStyle}
                      name="activa"
                      component={renderToggleButtonField}
                      value={activa}
                      onChange={handleChangeChecked}
                    />
                  </div>
                </div>
              </Col>
            </Form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <FormGroup row className="form">
                  <Col lg={3} md={4} sm={6} lx={12}>
                    <div className="form__form-group">
                      <span className="form__form-group-label">Filtrar alumnos:</span>
                      <div className="form__form-group-field">
                        <Field
                          name="filterValue"
                          component={TextBox}
                          placeholder="Texto a buscar"
                          autoComplete="false"
                          type="text"
                          onChange={handleFilterChangeText}
                          maxLength={32}
                          defaultValue={filterValue}
                        />
                      </div>
                    </div>
                  </Col>
                </FormGroup>
              </Col>
            </Row>

            <FieldArray
              key="encuestaMateriaAlumnos"
              name="encuestaMateriaAlumnos"
              component={StudentsScoresTable}
              items={encuestaMateriaAlumnos}
              puntajeTotal={0}
              editScore={false}
              sortColumn={sortColumn}
              sortType={sortType}
              onChangeText={handleChangeText}
              onSort={handleSort}
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxSurveyForm = reduxForm({
  form: 'SurveyForm',
  validate,
  enableReinitialize: true,
})(SurveyForm);

export default setPropsAsInitialValues(ReduxSurveyForm);
